import React from 'react';

import { LoaderWrapper } from './Styled';
import withTheme from '../../utils/styles/theme/withTheme';

const Loader = props => {
  const { children, isLoading } = props;
  return (
    <LoaderWrapper {...props}>
      <span data-loading={isLoading}>{children}</span>
    </LoaderWrapper>
  );
};

export default withTheme(Loader);
